import * as React from 'react';
import { useId, useBoolean } from '@fluentui/react-hooks';
import { EUSLBListItem } from '../../../model/EUSLBListItem';
import { useState, ChangeEvent, useEffect } from 'react';
import { CreateEUSLB } from "../../../services/AdminServices/EUSLBService";
import { useAuth } from "react-oidc-context";
import { Toggle } from '@fluentui/react/lib/Toggle';
import {
    getTheme,
    mergeStyleSets,
    FontWeights,
    ContextualMenu,
    IToggleProps,
    Modal,
    Dialog,
    IDragOptions,
    IIconProps,
    IStackTokens,
    Stack,
    IStackProps,
    DialogFooter,
    PrimaryButton,
    TextField,
    DialogType,
    MessageBar,
    MessageBarType



} from '@fluentui/react';
import { DeleteEUSLBById, UpdateEUSLBById } from "../../../services/AdminServices/EUSLBService";
import { initializeIcons } from '@fluentui/font-icons-mdl2';
import { DefaultButton, IconButton, IButtonStyles } from '@fluentui/react/lib/Button';
import styles from './EUSLB.module.css';
initializeIcons();




function EUSLBDeleteModal(props: any) {
    const auth = useAuth();


    const [hideDeleteDialogC, { toggle: toggleDeleteHideDialogC }] = useBoolean(true);

    const [error, setError] = useState('');

    const dialogContentProps = {
        type: DialogType.normal,

    };

    const modalProps = React.useMemo(
        () => ({
            isBlocking: true,
        }),
        [],
    );


    // Effect to handle itemsPerPage change and update displayed items
    useEffect(() => {
        if (props.deleteDialoghide) {
            console.log('close');
            props.resetDeleteDialoghide('close');


        } else {
            toggleDeleteHideDialogC();
            console.log('open');

        }



    }, [props.deleteDialoghide]);

    useEffect(() => {

        if (hideDeleteDialogC === true) {

            setError('');

            //reset is edit 
            props.resetDeleteDialoghide('close');
        }


    }, [hideDeleteDialogC]);

    const handleDeleteSubmit = () => {

        // Call the delete function (deleteEUSLB) with the provided id
        DeleteEUSLBById(props.deleteItem.encryptedId, auth.user?.id_token)
            .then((response) => {
                // Successful deletion, handle the response accordingly, e.g., update the user interface
                console.log('EUSLB item deleted successfully:', response);
                props.handleActionResponse('deletetrue');

                // Update the user interface, refresh the data list, etc.
            })
            .catch((error) => {
                // If there is an error during deletion, handle it, e.g., display an error message
                console.error('Error deleting EUSLB item:', error);
                props.handleActionResponse('deletefalse');
            });
        toggleDeleteHideDialogC();


    };



    return (
        <>
            <Dialog
                hidden={hideDeleteDialogC}
                onDismiss={toggleDeleteHideDialogC}
                modalProps={modalProps}
                dialogContentProps={dialogContentProps}
                minWidth="560px"
            >

                <div>
                    <h1>Delete legislative basis (ID: {props.deleteId})</h1>
                    <p>

                        Once you delete an EU sectoral legislative basis, it is no longer available in the relevant drop down list. Please confirm to proceed.
                    </p>
                </div>


                <DialogFooter>
                    {/* <PrimaryButton onClick={handleDialogClose} text="Save" />
               <DefaultButton onClick={handleDialogClose} text="Cancel" /> */}
                    <PrimaryButton text="Confirm" onClick={handleDeleteSubmit} />
                    <DefaultButton text="Cancel" onClick={toggleDeleteHideDialogC} />
                </DialogFooter>
            </Dialog>

        </>
    )
}


export default EUSLBDeleteModal;